import React from 'react';
import { useNavigate } from 'react-router-dom';

const PURPLE = '#200854';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="shadow-md" style={{ backgroundColor: PURPLE }}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/najsport-logo.png" alt="NajSport" className="h-8 w-auto" />
            <h1 className="text-lg font-bold text-white">Ochrana osobných údajov</h1>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-white hover:text-orange-300 transition-colors font-medium"
          >
            Späť
          </button>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 space-y-6 text-sm text-gray-700 leading-relaxed">

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>1. Prevádzkovateľ</h2>
            <p>
              Prevádzkovateľom aplikácie NajSport je NajSport s.r.o. (ďalej len „my" alebo „prevádzkovateľ").
              Kontakt: <strong>info@najsport.sk</strong>
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>2. Aké údaje zbierame</h2>
            <p className="mb-2">Pri používaní aplikácie zbierame nasledovné osobné údaje:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Identifikačné údaje:</strong> meno, priezvisko, e-mailová adresa (používa sa na prihlásenie a komunikáciu)</li>
              <li><strong>Kontaktné údaje:</strong> telefónne číslo (voliteľné)</li>
              <li><strong>Profilové údaje:</strong> úroveň jazdca, priemerné tempo, skúsenosti s jazdou v skupine, typ bicykla, model bicykla, veľkosť dresu</li>
              <li><strong>Fotografie:</strong> profilová fotka, fotky z eventov</li>
              <li><strong>Údaje o aktivite:</strong> rezervácie, účasť na jazdách, body, séria</li>
              <li><strong>Technické údaje:</strong> IP adresa, typ prehliadača (uchovávané max. 90 dní)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>3. Účel spracovania</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Poskytovanie služieb aplikácie (registrácia na jazdy, správa profilu)</li>
              <li>Komunikácia s používateľmi</li>
              <li>Bodovací systém a rebríček (gamifikácia)</li>
              <li>Zlepšovanie služieb a bezpečnosť aplikácie</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>4. Právny základ</h2>
            <p>
              Osobné údaje spracúvame na základe <strong>súhlasu používateľa</strong> (čl. 6 ods. 1 písm. a) GDPR)
              a na základe <strong>plnenia zmluvy</strong> (čl. 6 ods. 1 písm. b) GDPR) – t. j. poskytovania služieb,
              na ktoré sa používateľ zaregistroval.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>5. Tretie strany</h2>
            <p className="mb-2">Vaše údaje môžu byť zdieľané s nasledovnými tretími stranami:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Cloudflare (R2):</strong> ukladanie fotografií</li>
              <li><strong>Resend:</strong> odosielanie e-mailov</li>
              <li><strong>Hetzner:</strong> hosting servera a databázy (EÚ)</li>
            </ul>
            <p className="mt-2">Všetky tretie strany sú viazané zmluvami o spracovaní údajov a dodržujú GDPR.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>6. Viditeľnosť údajov v aplikácii</h2>
            <p className="mb-2">Niektoré vaše údaje sú viditeľné pre ostatných používateľov aplikácie:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Meno a priezvisko:</strong> zobrazujú sa ostatným účastníkom na jazdách, na ktoré ste prihlásení, a v rebríčku</li>
              <li><strong>Profilová fotka:</strong> zobrazuje sa pri vašom mene na jazdách a v rebríčku</li>
              <li><strong>Body a úroveň:</strong> zobrazujú sa v rebríčku</li>
            </ul>
            <p className="mt-2">E-mailová adresa, telefónne číslo a ostatné profilové údaje nie sú viditeľné pre ostatných používateľov.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>7. Doba uchovávania</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Osobné údaje: po dobu trvania účtu</li>
              <li>Technické logy (IP, user-agent): automaticky mazané po <strong>90 dňoch</strong></li>
              <li>Body a štatistiky: resetované na konci sezóny</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>8. Vaše práva</h2>
            <p className="mb-2">Podľa GDPR máte nasledovné práva:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Právo na prístup:</strong> môžete si stiahnuť všetky svoje údaje (v profile)</li>
              <li><strong>Právo na opravu:</strong> môžete upraviť svoje údaje v profile</li>
              <li><strong>Právo na vymazanie:</strong> môžete si zmazať účet (v profile)</li>
              <li><strong>Právo na prenosnosť:</strong> export údajov vo formáte JSON</li>
              <li><strong>Právo odvolať súhlas:</strong> kedykoľvek zmazaním účtu</li>
              <li><strong>Právo podať sťažnosť:</strong> na Úrad na ochranu osobných údajov SR</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>9. Fotografie z eventov</h2>
            <p>
              Pri prihlásení na jazdu používateľ súhlasí s možnosťou byť odfotografovaný počas eventu.
              Fotografie môžu byť zdieľané v rámci aplikácie. Ak si neželáte byť na fotografiách,
              kontaktujte nás na <strong>info@najsport.sk</strong>.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>10. Cookies a lokálne úložisko</h2>
            <p>
              Aplikácia používa lokálne úložisko prehliadača (localStorage) na uchovanie prihlasovacieho tokenu
              a základných údajov profilu pre správne fungovanie. Nepoužívame sledovacie cookies ani analytické nástroje tretích strán.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold mb-2" style={{ color: PURPLE }}>11. Kontakt</h2>
            <p>
              V prípade otázok ohľadne ochrany osobných údajov nás kontaktujte na: <strong>info@najsport.sk</strong>
            </p>
          </div>

          <div className="text-xs text-gray-400 pt-4 border-t">
            Posledná aktualizácia: 11. apríl 2026
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
